<div class="oa-sheet approve-dialog">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>
            Aprovar orçamento {{ number }}
            <span class="oa-sheet__subtitle">
                <ng-container *ngIf="requiresMethod">Informe como {{ clientName }} vai pagar. </ng-container>
                Total do orçamento: <b>{{ money(total) }}</b>
            </span>
        </h2>
        <button type="button" class="oa-icon-btn" mat-dialog-close aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="oa-sheet__body approve-dialog__body">
        <div *ngIf="loading" class="approve-dialog__loading"><mat-spinner diameter="28"></mat-spinner></div>

        <ng-container *ngIf="!loading">
            <div class="approve-dialog__date">
                <mat-form-field appearance="outline" class="approve-dialog__date-field">
                    <mat-label>Data de aprovação</mat-label>
                    <input matInput required [matDatepicker]="picker" [(ngModel)]="date" [max]="today" readonly
                        (click)="picker.open()" aria-required="true">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <span class="approve-dialog__hint">Dia em que o cliente aprovou. Usada nos relatórios e no faturamento.</span>
            </div>

            <ng-container *ngIf="requiresMethod">
                <p class="approve-dialog__label" id="approve-method-label">
                    Forma de pagamento <span class="approve-dialog__required" aria-hidden="true">*</span>
                </p>
                <div role="radiogroup" aria-labelledby="approve-method-label" class="approve-dialog__methods">
                    <oa-radio-card *ngFor="let option of options" [title]="option.title" [description]="option.description"
                        [icon]="option.icon" [value]="option.value" [selected]="selected === option" (select)="pick(option)">
                        <oa-installment-picker *ngIf="option.plans.length > 1" [options]="option.picker"
                            [value]="installments" (valueChange)="installments = $event"
                            [ariaLabel]="'Parcelas de ' + option.title"></oa-installment-picker>
                    </oa-radio-card>
                </div>

                <div *ngIf="chosenPlan" class="approve-dialog__chosen" aria-live="polite">
                    <b>{{ chosenTitle }}</b>
                    <span>{{ chosenDetail }}</span>
                </div>
            </ng-container>

            <oa-notice *ngIf="missing" tone="warning">{{ missing }}</oa-notice>
        </ng-container>
    </div>

    <footer class="oa-sheet__footer">
        <button type="button" class="oa-btn oa-btn--ghost" mat-dialog-close>Cancelar</button>
        <button type="button" class="oa-btn oa-btn--primary" [disabled]="!!missing || loading" (click)="approve()">
            <mat-icon>thumb_up</mat-icon>
            Aprovar
        </button>
    </footer>
</div>
